<template>
    <ValidationProvider :name="name" :rules="field._validation" :vid="name" v-slot="validator">
        <b-field>
            <EvoLabel slot="label" :name="inputName" :field="field" :validator="validator"></EvoLabel>

            <div v-if="field._mask" class="control text-input is-clearfix">
            <imask-input

                class="input"
                :class="validator.failed ? 'input_error' : ''"
                v-model="value"

                :mask="field._mask._mask"
                :unmask="field._mask._unmask"
                :prepare="field._mask._prepare"
                :validate="field._mask._validate"
                :commit="field._mask._commit"
                :overwrite="field._mask._overwrite"
                :placeholderChar="field._mask._placeholder_char"
                :lazy="field._mask._lazy"
                :definitions="field._mask._definitions"
                :blocks="field._mask._blocks"
                :pattern="field._mask._pattern"
                :format="field._mask._format"
                :parse="field._mask._parse"
                :autofix="field._mask._autofix"
                :radix="field._mask._radix"
                :thousandsSeparator="field._mask._thousands_separator"
                :mapToRadix="field._mask._map_to_radix"
                :scale="field._mask._scale"
                :signed="field._mask._signed"
                :normalizeZeros="field._mask._normalize_zeros"
                :padFractionalZeros="field._mask._pad_fractional_zeros"
                :min="field._mask._min"
                :max="field._mask._max"
                :dispatch="field._mask._dispatch"
                :placeholder="field._placeholder"
            />
            </div>

            <b-input v-else v-model="value" :name="inputName" :id="inputName" class="text-input"
                     :custom-class="validator.failed ? 'input_error' : ''"
                     :placeholder="field._placeholder" :type="field._type"/>
        </b-field>
        <EvoError v-if="validator.errors[0]" :validator="validator"></EvoError>
    </ValidationProvider>
</template>

<script>
import mixin from "./mixin";

import {IMaskComponent} from 'vue-imask';

export default {
    mixins: [mixin],
    components: {'imask-input': IMaskComponent},
    computed: {
        inputName() {
            switch (this.name) {
                case 'street_box_number':
                    return 'box';
                    break;
                case 'street':
                    return 'evo_rue';
                    break;
                case 'street_number':
                    return 'evo_rue_num';
                    break;
                default:
                    return this.name;
            }
        }
    },
}
</script>
